/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Access_Level_Org_HintInputs */



/**
* | output |
* | --- |
* | "Anyone in the organization can select this model." |
*
* @param {Model_Access_Level_Org_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const model_access_level_org_hint = /** @type {((inputs?: Model_Access_Level_Org_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Access_Level_Org_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle in der Organisation können dieses Modell auswählen.")
	return /** @type {LocalizedString} */ ("Anyone in the organization can select this model.")
});